/**
 * Pagina pubblica "Stima Costo Ricostruzione Fabbricato"
 * Route: /stima-costo-ricostruzione
 */
import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PrivacyLinks from "@/components/PrivacyLinks";
import StimaCostoRicostruzioneWizard from "@/components/common/StimaCostoRicostruzioneWizard";
import { Building2, Shield, Clock, Award } from "lucide-react";

export default function StimaCostoRicostruzionePage() {
  return (
    <div className="bg-[#FAFAF7] min-h-screen">
      <Header />
      <main className="pt-24 pb-12">
        {/* Hero */}
        <section className="max-w-5xl mx-auto px-4 mb-10 text-center">
          <Building2 className="w-12 h-12 mx-auto mb-4 text-[#163321]" />
          <h1 className="font-heading text-3xl sm:text-4xl text-[#163321] mb-3">
            Stima Costo Ricostruzione Fabbricato
          </h1>
          <p className="text-zinc-600 max-w-2xl mx-auto">
            Compila i dati del tuo immobile: un nostro consulente ti contatterà entro 24 ore con
            la valutazione tecnica completa, base ideale per dimensionare la tua polizza danni
            ai fabbricati senza rischi di sotto-assicurazione.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-8 max-w-3xl mx-auto">
            <div className="bg-white rounded-xl p-4 border border-zinc-100">
              <Shield className="w-5 h-5 mx-auto text-[#163321] mb-2" />
              <div className="text-xs text-zinc-500">Metodologia</div>
              <div className="text-sm font-semibold">Prezziari pubblici 2024-2025</div>
            </div>
            <div className="bg-white rounded-xl p-4 border border-zinc-100">
              <Clock className="w-5 h-5 mx-auto text-[#163321] mb-2" />
              <div className="text-xs text-zinc-500">Risposta</div>
              <div className="text-sm font-semibold">Entro 24 ore lavorative</div>
            </div>
            <div className="bg-white rounded-xl p-4 border border-zinc-100">
              <Award className="w-5 h-5 mx-auto text-[#163321] mb-2" />
              <div className="text-xs text-zinc-500">Valutazione</div>
              <div className="text-sm font-semibold">Profilo geo + tecnologie</div>
            </div>
          </div>
        </section>

        {/* Wizard */}
        <section className="max-w-3xl mx-auto px-4">
          <StimaCostoRicostruzioneWizard mode="public" />
        </section>

        {/* Note */}
        <section className="max-w-3xl mx-auto px-4 mt-8 text-xs text-zinc-500 text-center">
          La stima fornita dall'agenzia Colucci è una <strong>valutazione tecnica di parte</strong>,
          non una perizia ufficiale. Si basa su prezziari pubblici (Osservatorio ANCE, CCIAA, ISTAT,
          NTC 2018, DPR 412/93) e sui dati anagrafici da te forniti. Il valore finale per la polizza
          è vincolato a verifica documentale o sopralluogo.
          <div className="mt-3"><PrivacyLinks /></div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
